import { Text_16_24 } from '@dreamstack/feature-components/src/layout/Texts'
import type { BlockRibbon } from '@dreamstack/payload/src/payload-types'
import { cn } from '@dreamstack/util/src/cn'
import { motion } from 'framer-motion'
import type { FunctionComponent } from 'react'

const RibbonContainer = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<
  { className?: string } & Parameters<typeof motion.div>[0]
>) => (
  <motion.div
    className={cn(
      'flex whitespace-nowrap justify-between my-px-20 md:my-px-40',
      className
    )}
    {...rest}
  >
    {children}
  </motion.div>
)

const Heading = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <h1
    className={cn(
      'font-semibold text-[96px] leading-[90px] md:text-[144px] md:leading-[130px] lg:text-[220px] lg:leading-[200px] tracking-[-3.44px]',
      className
    )}
    {...rest}
  >
    {children}
  </h1>
)

const Separator = ({
  className,
  ...rest
}: { className?: string } & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'flex flex-1 mx-px-48 w-px-64 md:w-px-96 ml:w-[166px] ml:mx-px-64 border-b-4 border-black h-[3px] self-center',
      className
    )}
    {...rest}
  />
)

interface SubHeadingProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
}
const SubHeading: React.FC<SubHeadingProps> = ({
  className,
  children,
  ...rest
}) => (
  <Text_16_24
    className={cn(
      'font-semibold pl-px-8 pt-px-12 md:pl-px-12 md:pt-px-16 lg:pl-px-20',
      className
    )}
    {...(rest as any)}
  >
    {children}
  </Text_16_24>
)

export const TextRibbonContainer: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockRibbon
  }>
> = ({ block }) => {
  return (
    <RibbonContainer layout="position">
      <Separator />
      <div>
        <Heading>{block.heading1}</Heading>
        <SubHeading>{block.subheading1}</SubHeading>
      </div>
      <Separator />
      <div>
        <Heading>{block.heading2}</Heading>
        <SubHeading>{block.subheading2}</SubHeading>
      </div>
      <Separator />
      <div>
        <Heading>{block.heading3}</Heading>
        <SubHeading>{block.subheading3}</SubHeading>
      </div>
    </RibbonContainer>
  )
}
